import type { MetaFunction } from 'react-router'
import { Link } from 'react-router'
import { STATIC_PAGE_HEADERS } from '~/lib/cache.server'
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: "Droit d'accès aux données personnelles — AfficheServices" },
  { name: 'description', content: "Exercez votre droit d'accès RGPD : demandez une copie de toutes les données personnelles détenues par AfficheServices." },
  { name: 'robots', content: 'noindex,follow' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/droit-acces' },
]

export default function DroitAcces() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto max-w-3xl px-4 py-16 lg:px-6">
        <h1 className="text-3xl font-bold text-slate-900">Droit d'accès aux données personnelles</h1>
        <p className="mt-2 text-sm text-slate-500">Conformité RGPD — Article 15 du Règlement (UE) 2016/679</p>

        <article className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed">
          <h2>Votre droit d'accès</h2>
          <p>
            Conformément à l'article 15 du Règlement Général sur la Protection des Données (RGPD),
            vous avez le droit d'obtenir du responsable de traitement la confirmation que des données
            personnelles vous concernant sont ou ne sont pas traitées. Lorsqu'elles le sont, vous
            pouvez obtenir une copie de l'ensemble de ces données.
          </p>

          <h2>Quelles données pouvons-nous détenir ?</h2>
          <ul>
            <li><strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</li>
            <li><strong>Données de compte :</strong> date d'inscription, rôle (particulier ou professionnel), historique de connexion</li>
            <li><strong>Données de demandes :</strong> demandes de devis, descriptions de projets, échanges avec les artisans</li>
            <li><strong>Données professionnelles :</strong> SIRET, raison sociale, adresse, certifications (pour les professionnels)</li>
            <li><strong>Données d'avis :</strong> évaluations, commentaires, photos de projets</li>
            <li><strong>Données techniques :</strong> adresse IP, cookies de session, préférences de notification</li>
          </ul>

          <h2>Comment exercer votre droit</h2>
          <p>Envoyez votre demande par email à :</p>
          <p className="rounded-xl bg-slate-50 p-4">
            <strong>Email :</strong>{' '}
            <a href="mailto:rgpd@afficheservices.fr" className="text-primary">rgpd@afficheservices.fr</a><br />
            <strong>Objet :</strong> Demande d'accès aux données personnelles<br />
            <strong>Joindre :</strong> une copie de votre pièce d'identité (pour vérification)
          </p>

          <h2>Délai de réponse</h2>
          <p>
            Nous répondons dans un délai maximum de <strong>30 jours</strong> à compter de la réception
            de votre demande complète (incluant la vérification d'identité). Ce délai peut être prolongé
            de deux mois supplémentaires si la demande est complexe, auquel cas nous vous en informerons
            dans le premier mois.
          </p>

          <h2>Format de la réponse</h2>
          <p>
            Les données vous seront transmises dans un format structuré, couramment utilisé et lisible
            par machine (JSON ou CSV), sauf si vous demandez un autre format. La transmission se fait
            par email chiffré ou via un lien sécurisé à usage unique.
          </p>

          <h2>Gratuité</h2>
          <p>
            La première copie est gratuite. En cas de demandes manifestement infondées ou excessives
            (répétitives), nous pouvons facturer un frais raisonnable basé sur le coût administratif,
            conformément à l'article 12.5 du RGPD.
          </p>

          <h2>Autres droits</h2>
          <p>
            Vous disposez également d'un{' '}
            <Link to="/droit-opposition" className="text-primary hover:underline">droit d'opposition</Link>,
            d'un droit de rectification, d'un droit à l'effacement et d'un droit à la portabilité.
            Consultez notre{' '}
            <Link to="/confidentialite" className="text-primary hover:underline">politique de confidentialité</Link>
            {' '}pour plus de détails.
          </p>

          <h2>Réclamation</h2>
          <p>
            Si vous estimez que le traitement de vos données ne respecte pas la réglementation, vous
            pouvez introduire une réclamation auprès de la{' '}
            <a href="https://www.cnil.fr/plaintes" target="_blank" rel="noreferrer" className="text-primary hover:underline">CNIL</a>
            {' '}(Commission Nationale de l'Informatique et des Libertés).
          </p>
        </article>
      </div>
      <Footer />
    </div>
  )
}
